import { render } from "./Dashboard.vue?vue&type=template&id=fa0bed74&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-fa0bed74"

export default script